import { Select } from "@chakra-ui/select";
import { FC, useMemo } from "react";

import { useAppDispatch, useAppSelector } from "app/hook";
import {
  setPageDefault,
  setQuestionType,
} from "app/features/questionFilter/questionFilterSlice";

interface QuestionTypeSelectProps {}

const QUESTION_TYPE_OPTIONS = [
  { label: "True/False", value: "tf" },
  { label: "MCQS (Single choice)", value: "mcqs" },
  { label: "MCQM (Multiple choice)", value: "mcqm" },
  { label: "Short Answer", value: "short" },
  { label: "Long Answer", value: "la" },
  { label: "Diagram", value: "diagram" },
];

const QuestionTypeSelect: FC<QuestionTypeSelectProps> = () => {
  const { questionType } = useAppSelector((state) => state.filterQuestion);
  const dispatch = useAppDispatch();

  // Ensure the value we bind to the Select is one of our canonical values
  const currentValue = useMemo(() => {
    if (!questionType) return "";
    const v = String(questionType).toLowerCase();
    const exists = QUESTION_TYPE_OPTIONS.some((opt) => opt.value === v);
    return exists ? v : "";
  }, [questionType]);

  return (
    <Select
      placeholder="Question Types"
      size="sm"
      rounded="md"
      value={currentValue}
      display={{ base: "none", md: "block", lg: "block" }}
      onChange={(e) => {
        // Always store canonical lowercase value in state
        const val = e.target.value;
        dispatch(setQuestionType(val));
        dispatch(setPageDefault());
      }}
      width="220px"
    >
      {QUESTION_TYPE_OPTIONS.map((opt) => (
        <option key={opt.value || "all"} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </Select>
  );
};

export default QuestionTypeSelect;
